<ng-container *ngIf="individualId$ | async; let individualId">
  <ng-container *appLoad="let individualSummary of individualSummary$; errorSizeClass: 'sm'; trackingName: 'individual-layout'">
    <spark-layout>

      <!-- slot / menu -->
      <layout-side-menu>

        <spark-shared-sidebar-sub-menu
          heading="Contacts"
          [backRoute]="['/Contacts']"
          [routePrefix]="routePrefix"
          [items]="items">
        </spark-shared-sidebar-sub-menu>

      </layout-side-menu>

      <!-- slot / content -->
      <layout-content>

        <div class="row">
          <div class="col individual">
            <div class="individual__header">
              <spark-contacts-individual-summary-panel
                [individualSummary]="individualSummary">
              </spark-contacts-individual-summary-panel>
            </div>
            <div class="individual__content">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>

      </layout-content>

    </spark-layout>
  </ng-container>
</ng-container>
